import SigliveServiceV1 from 'Service/sigliveServiceV1';

const patchStudio = async ({ payload, id }) => {
  const { data } = await SigliveServiceV1({ method: 'PATCH', url: `/studio/${id}`, data: payload });

  return data;
};

export default patchStudio;
